import isElectron from 'is-electron';
import { getElectronGlobalProperties } from '../electron-bridge/electron-bridge';

export type ElectronProperties = {
    ELECTRON_MAIN_VERSION: string | undefined;
};

export type GlobalProperties = {
    ENVIRONMENT?: 'dev43' | 'qa' | 'staging' | 'production' | 'govhigh';
    VERSION: string;
    ELECTRON_MAIN_VERSION: string | undefined;
    DATADOG_CLIENT_TOKEN: string;
    DATADOG_APPLICATION_ID: string;
};

// we deliberately do casting here instead of adding these things to our Window type because
// we want people to be accessing global properties via this function rather than access them
// directly on the window which may be unsafe
const globalPropertiesFromWindow: GlobalProperties = {
    ENVIRONMENT: ((window as unknown) as { ENVIRONMENT: GlobalProperties['ENVIRONMENT'] })
        .ENVIRONMENT,
    VERSION: process.env.APP_VERSION as string,
    ELECTRON_MAIN_VERSION: undefined,
    DATADOG_CLIENT_TOKEN: ((window as unknown) as {
        DATADOG_CLIENT_TOKEN: GlobalProperties['DATADOG_CLIENT_TOKEN'];
    }).DATADOG_CLIENT_TOKEN,
    DATADOG_APPLICATION_ID: ((window as unknown) as {
        DATADOG_APPLICATION_ID: GlobalProperties['DATADOG_APPLICATION_ID'];
    }).DATADOG_APPLICATION_ID,
};

/**
 * GlobalProperties come from different sources in Electron and on Web. In Electron we retrieve GlobalProperties via an ipc
 *   call to the electron main process (can be found in preload.ts). In Web, global properties are read from the window and process.env.
 *   In web values for these global properties will have been set into our index.html file by changeHash.sh or by vite (in the case of process.env stuff).
 * This function exists to allow access to global properties throughout the application without the consumer having to handle the
 * "web vs electron" consideration.
 */
export async function getGlobalProperties(): Promise<GlobalProperties> {
    if (isElectron()) {
        const electronProperties = await getElectronGlobalProperties();
        return {
            ...globalPropertiesFromWindow,
            ELECTRON_MAIN_VERSION: electronProperties.ELECTRON_MAIN_VERSION,
        };
    }
    return globalPropertiesFromWindow;
}
